module.exports = __webpack_public_path__ + "static/syllabus-0fa46f263ec65476ed7bfc67b197b384.png";